import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  EducatorWriteReviewCreateReviewMutation,
  EducatorWriteReviewCreateReviewMutationVariables,
} from '@gql/graphql';
import type { EducatorWriteReviewFormValues } from '@presentation/pages';
import { useCallback } from 'react';
import { EDUCATOR_GET_EDUCATOR } from '../../EducatorPageController/api/useGetEducator';
import { EDUCATOR_REVIEW_GET_EDUCATOR } from './useGetEducator';

export const EDUCATOR_WRITE_REVIEW_CREATE_REVIEW = graphql(`
  mutation EducatorWriteReviewCreateReview($data: CreateEducatorReviewInput!) {
    createEducatorReview(data: $data) {
      id
    }
  }
`);

export const useWriteReview = () => {
  const [writeReview, { data, loading, error }] = useMutation<
    EducatorWriteReviewCreateReviewMutation,
    EducatorWriteReviewCreateReviewMutationVariables
  >(EDUCATOR_WRITE_REVIEW_CREATE_REVIEW, {
    awaitRefetchQueries: true,
    refetchQueries: [EDUCATOR_GET_EDUCATOR, EDUCATOR_REVIEW_GET_EDUCATOR],
  });

  const writeReviewFromFrom = useCallback(
    (form: EducatorWriteReviewFormValues, professionalId?: number) => {
      if (!professionalId) throw new Error('educatorId is not defined');

      return writeReview({
        variables: {
          data: {
            professionalId,
            grade: form.grade,
            description: form.description,
            verified: false,
          },
        },
      });
    },
    [writeReview],
  );

  return {
    writeReviewFromFrom,
    writeReviewLoading: loading,
    writeReviewData: data,
    writeReviewError: error,
  };
};
